// @flow
import { useState, useEffect, useRef } from 'react';

/**
 * Returns [ref, isVisible].
 * isVisible becomes true once the element enters the viewport (sticky – never goes back to false).
 */
export default function useInView(options?: IntersectionObserverInit = { threshold: 0.15 }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || visible) return undefined;

    if (!window.IntersectionObserver) {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, options);

    observer.observe(el);
    return () => observer.disconnect();
  }, [visible, options]);

  return [ref, visible];
}
